import { render, staticRenderFns } from "./AdditionalServices.vue?vue&type=template&id=065a7444&"
import script from "./AdditionalServices.vue?vue&type=script&lang=ts&"
export * from "./AdditionalServices.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports